import React from "react";

/**
 * props
 * onAction {function}
 * actionValue {any} A value we want to pass when button is clicked
 * buttonText {String}
 * customClasses? {String}
 * position? {String} left | right
 * image? {String}
 */
function CTAButton(props) {
    // const images = require.context('../../assets', true);
    // const img = props.image ? images('./' + props.image) : "";
    const imag = props.image ?require('../../assets/'+ props.image): "";

    return (
        <div onClick={props.onAction.bind(this, props.actionValue)} className={`ctabutton ${props.customClasses || '' }`}>
            {props.position === 'left' && <img className={'icon_button-icon-left'} src={imag.default} alt={'icono de adoptzi'}/>}
            <p className={'ctabutton__text'}>{props.buttonText}</p>
            {props.position === 'right' && <img className={'icon_button-icon-right'} src={imag.default} alt={'icono de adoptzi'}/>}
        </div>
    );
}

export default CTAButton;